import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Users.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: a }));
o.displayName = "UsersIcon";
const n = o;
export {
  n as Users,
  o as UsersIcon
};
